import { Row, Col } from "antd";
import CompanyProfile from "./CompanyProfile";
import SubscriptionPayments from "./SubscriptionPayments";
import InvoiceSettings from "./InvoiceSettings";
import ProposalSettings from "./ProposalSettings";
import AppSettings from "./AppSettings";
import SupportSection from "./SupportSection";
import "./organization.css";

function OrganizationWorkspace({ activeTab = "company", onOpenForgotPwd }) {
  if (activeTab === "invoice_settings") {
    return <InvoiceSettings />;
  }

  if (activeTab === "proposal_settings") {
    return <ProposalSettings />;
  }

  if (activeTab === "settings") {
    return <AppSettings />;
  }

  if (activeTab === "support") {
    return <SupportSection />;
  }

  // Default: "company" (Company Profile & Subscriptions)
  return (
    <div className="org-workspace-container">
      <Row gutter={[20, 20]}>
        {/* Left Column: Profile & Change Password */}
        <Col xs={24} xl={11}>
          <CompanyProfile onOpenForgotPwd={onOpenForgotPwd} />
        </Col>

        {/* Right Column: Subscription & Payment History */}
        <Col xs={24} xl={13}>
          <SubscriptionPayments />
        </Col>
      </Row>
    </div>
  );
}

export default OrganizationWorkspace;
